<template>
  <div>
    <div class="tw-flex tw-justify-between tw-flex-wrap section-heading">
      <div>
        <h4>Products Review</h4>
        <p>
          Below is the list of the products you’ve chosen, categorized by
          platform. Please review and confirm before proceeding.
        </p>
      </div>
      <div class="tw-flex tw-gap-4">
        <div class="tw-border-r-[1px] tw-border-[#d4d4d4] tw-pr-4">
          <div class="tw-text-[14px] tw-text-[#5e5e5e] tw-font-[400]">
            Allowed Limit
          </div>
          <div class="tw-text-[16px] tw-text-[#5e5e5e] tw-font-[600] tw-mt-2">
            {{ productLength[0].allowed_limit }}
          </div>
        </div>
        <div class="tw-border-r-[1px] tw-border-[#d4d4d4] tw-pr-4">
          <div class="tw-text-[14px] tw-text-[#5e5e5e] tw-font-[400]">
            Uploaded Products
          </div>
          <div class="tw-text-[16px] tw-text-[#5e5e5e] tw-font-[600] tw-mt-2">
            {{ productLength[0].uploaded_products }}
          </div>
        </div>
        <div>
          <div class="tw-text-[14px] tw-text-[#5e5e5e] tw-font-[400]">
            Remaining Slots
          </div>
          <div class="tw-text-[16px] tw-text-[#5e5e5e] tw-font-[600] tw-mt-2">
            {{ productLength[0].remaining_slots }}
          </div>
        </div>
      </div>
    </div>
   
    <!-- Table for products review -->
    <div class="preview-controls">
      <select
        class="demo-select"
        v-model="selectedFilterPlatform"
        @change="getProductsReview"
      >
        <option
          v-for="platform of selectedPlatforms"
          :key="platform.platform_id"
          :value="platform"
        >
          {{ platform.platform_name }}
        </option>
      </select>
      <button class="primarycolor" @click="exportExcel">
        Export
      </button>
       <button class="primarycolor float-right tw-block" @click="exportExcelAll">
        Export all
    </button>
    </div>
    <div v-if="tableData.length">
      <table id="products_review_tbl" class="w-100">
        <thead>
          <tr>
            <th v-for="colHeader of tableHeaders" :key="colHeader.key">
              {{ colHeader.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, idx) of tableData" :key="idx">
            <td
              v-for="col of tableHeaders"
              :key="col.key + idx"
              class="px-4 py-3"
            >
              <template v-if="col.key === 'product_url'">
                <a :href="row[col.key]" target="_blank">{{ row[col.key] }}</a>
              </template>
              <template v-else-if="col.key === 'category'">
               <div  class="tw-capitalize">{{ row.category.replaceAll("_"," ") }}</div>
              </template>
              <template v-else>{{ row[col.key] }}</template>
              <div
                v-if="col.key === 'actions'"
                class="tw-flex tw-justify-center tw-gap-3"
              >
                <img
                  src="../../../../../public/Icons_SVG/editBtn.svg"
                  alt="Edit"
                  class="tw-cursor-pointer"
                  @click="openUpdateModal(row)"
                />
                <img
                  src="../../../../../public/Icons_SVG/deleteBtnSvg.svg"
                  alt="Delete"
                  class="tw-cursor-pointer"
                  @click="openDeleteModal(row)"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="noData" style="margin-top: 70px">
      No data to show. Please make sure that products are uploaded platform wise
      on the previous page.
    </div>
    <b-modal
      size="lg"
      class="customModal"
      id="productsReviewModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      v-model="showProductsReviewModal"
      title="Update Product"
    >
      <div>Item ID</div>
      <input
        type="text"
        v-model="updateProductId"
        placeholder="Enter SKU"
        class="form-control mb-3"
      />
    
      <div class="tw-mb-1">Family Name</div>
      <input
        type="text"
        v-model="updateProductName"
        placeholder="Enter Family Name"
        class="form-control mb-3"
      />
      <div class="tw-mb-1">Product Name</div>
      <input
        type="text"
        v-model="updateVariantName"
        placeholder="Enter Product Name"
        class="form-control mb-3"
      />
      <div class="tw-mb-1">Product URL</div>
      <input
        type="text"
        v-model="updateProductURL"
        placeholder="Enter Product URL"
        class="form-control mb-3"
      />
      <div>
        <button
          class="btn primarycolor tw-float-right"
          @click="handleUpdateProduct"
        >
          Save
        </button>
      </div>
    </b-modal>
    <b-modal
      size="md"
      class="customModal"
      id="productsReviewModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      v-model="showDeleteModal"
      title="Delete Product"
    >
      <h5>Are you sure you want to delete this product?</h5>
      <div>
        <button
          class="btn primarycolor tw-bg-[#ff0000c0] tw-float-right tw-mt-4"
          @click="handleDeleteProduct"
        >
          Delete
        </button>
      </div>
    </b-modal>
    <div class="mt-4">
      <div class="d-flex">
        <button
          class="primarycolor mr-3"
          @click="setSelectedSection(nextSection)"
        >
          Next
        </button>
        <button
          class="navigationButton"
          @click="setSelectedSection(previousSection)"
        >
          Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "ProdcutsReview",
  data() {
    return {
      selectedFilterPlatform: null,
      tableData: [],
      tableHeaders: [],
      currentSectionIndex: null,
      nextSection: null,
      previousSection: null,
      productLength: [],
      deleteProduct: null,
      showProductsReviewModal: false,
      showDeleteModal: false,
      storedUpdateProduct: null,
      updateProductId: "",
      updateProductName: "",
      updateVariantName:'',
      updateProductURL: "",
      dataForExcel: [],
      isExportTableData:false
    };
  },
  computed: {
    ...mapState("DemoStore", [
      "selectedFeatures",
      "selectedPlatforms",
      "sections",
      "selectedSection",
    ]),
  },
  mounted() {
    if (this.selectedPlatforms.length) {
      this.selectedFilterPlatform = this.selectedPlatforms[0];
      this.getProductsReview();
    } else {
      this.getFeatureWisePlatform();
    }
    this.currentSectionIndex = this.sections.indexOf(this.selectedSection);
    this.nextSection = this.sections[this.currentSectionIndex + 1];
    this.previousSection = this.sections[this.currentSectionIndex - 1];
    this.getTotalProductsLength();
  },
  methods: {
    ...mapActions("DemoStore", [
      "setDemoLoader",
      "setTotalPlatforms",
      "setSelectedPlatforms",
      "setSelectedSection",
    ]),

    exportExcel(){
      const url = "/api/v2/indian_clients/product_review/data_excel"
      this.isExportTableData = true
      const payload = {...this.dataForExcel}
      this.$http.post(url,payload).then((res) => {
          window.location = res.body.data;
          this.isExportTableData = false
        })
        .catch((err) => {
          this.isExportTableData = false
          console.error("Error exporting excel", err);
        });
    },
     exportExcelAll(){
      const url = "/api/demo/all_products"
      this.isExportTableData = true
      const payload = {...this.dataForExcel}
      this.$http.get(url).then((res) => {
          window.location = res.body.data;
          this.isExportTableData = false
        })
        .catch((err) => {
          this.isExportTableData = false
          console.error("Error exporting excel", err);
        });
    },

    getTotalProductsLength() {
      const url = "api/demo/total_products";

      this.$http
        .get(url)
        .then((res) => {
          this.productLength = res.data.data;
        })
        .catch((err) => {
          console.error("Error fetching total products length", err);
        });
    },
    getFeatureWisePlatform() {
      this.setDemoLoader(true);
      const url = "/api/demo/feature_platform";
      const payload = {
        feature_ids: this.selectedFeatures.map((feature) => feature.feature_id),
        region_id: this.$store.state.DemoStore.selectedRegion.id,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          let resData = res.body.data;
          let filteredSelectedPlatforms = [];

          if (resData.length)
            filteredSelectedPlatforms = resData.filter(
              (platform) => platform.isSelected && platform
            );

          this.setTotalPlatforms(resData);
          this.setSelectedPlatforms(filteredSelectedPlatforms);
          this.selectedFilterPlatform = filteredSelectedPlatforms[0];
          this.getProductsReview();
          this.setDemoLoader(false);
        })
        .catch((err) => {
          this.setDemoLoader(false);
        });
    },
    getProductsReview() {
      this.tableHeaders = [];
      this.tableData = [];
      $("#products_review_tbl").DataTable().destroy();
      // if ($.fn.DataTable.isDataTable("#myTable")) {
      //   $("#myTable").DataTable().destroy();
      // }
      this.setDemoLoader(true);

      const url = `/api/demo/products?platform_id=${this.selectedFilterPlatform.platform_id}&region_id=${this.$store.state.DemoStore.selectedRegion.id}`;

      this.$http
        .get(url)
        .then((res) => {
          this.dataForExcel = res.body;
          this.tableHeaders = res.body.headers;
          this.tableData = res.body.data;
          this.tableHeaders.push({
            label: "Actions",
            key: "actions",
          });
          this.$nextTick(() => {
            this.processTable("#products_review_tbl");
            this.setDemoLoader(false);
          });
        })
        .catch((err) => {
          console.log("Erron in getting products to review", err);
          this.setDemoLoader(false);
        });
    },
    openDeleteModal(data) {
      this.deleteProduct = data;
      this.showDeleteModal = true;
    },
    openUpdateModal(data) {
      this.storedUpdateProduct = data;
      this.updateProductId = data.item_id;
      this.updateProductName = data.product_name;
      this.updateVariantName = data.variant_name
      this.updateProductURL = data.product_url;
      this.showProductsReviewModal = true;
    },
    handleUpdateProduct() {
      const url = "/api/demo/product_update";
      const payload = {
        matching_fields: {
          sku: this.storedUpdateProduct.sku,
          platform_id: this.selectedFilterPlatform.platform_id,
        },
        updating_fields: {
          item_id: this.updateProductId,
          product_name: this.updateProductName,
          variant_name: this.updateVariantName,
          product_url: this.updateProductURL,
        },
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.showProductsReviewModal = false;
          this.getProductsReview();
          this.$bvToast.toast("Updated successfully", {
            title: "Success",
            variant: "success",
            solid: true,
            autoHideDelay: 3000,
            toaster: "b-toaster-top-center",
          });
          // this.updateProductId = "";
          // this.updateProductName = "";
          // this.updateProductURL = "";
        })
        .catch((err) => {
          console.error("Error updating product", err);
        });
    },
    handleDeleteProduct() {
      const url = "/api/demo/product_delete";
      const payload = {
        platform_id: this.selectedFilterPlatform.platform_id,
        skus: [this.deleteProduct.sku],
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.showDeleteModal = false;
          this.getProductsReview();
          this.deleteProduct = null;
          this.$bvToast.toast("Deleted successfully", {
            title: "Success",
            variant: "success",
            solid: true,
            autoHideDelay: 3000,
            toaster: "b-toaster-top-center",
          });
        })
        .catch((err) => {
          console.error("Error deleting product", err);
        });
    },
    processTable(id) {
      $(id).DataTable({
        initComplete: function (settings, json) {
          $(".dataTables_scrollBody tfoot tr").css({ visibility: "collapse" });
          $(".dataTables_scrollBody thead tr").css({ visibility: "collapse" });
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          searchPlaceholder: "Search...",
        },
        lengthChange: false,
        pagingType: "full_numbers",
        searching: true,
        sorting: [[0, "asc"]],
        autoWidth: false,
        info: false,
      });
      let search = require("../../../../../public/Icons_SVG/Search.svg");
      $(id + "_filter > label").append(`<div><img src='${search}' /></div>`);
    },
  },
};
</script>

<style scoped>
.preview-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  right: 2.5%;
  top: 230px;
  z-index: 50;
}
.demo-select {
  font-family: "Poppins", sans-serif;
  color: var(--primary_brand);
  background-color: transparent;
  padding-inline: 16px;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #065559 !important;
  border-radius: 5px;
  margin-inline: 5px;
  height: 35px;
}

.demo-select:focus {
  border: 1px solid #065559 !important;
  box-shadow: none !important;
  outline: none !important;
}

.demo-btn {
  color: #919191;
  background-color: transparent;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  padding: 6px 12px;
  margin-right: 20px;
  margin-bottom: 12px;
}

.demo-btn.active {
  color: var(--primary_brand);
  border: 1px solid var(--primary_brand);
}

.demo-btn:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #ebebeb !important;
}

.demo-btn.active:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
}

.section-heading h4 {
  font-size: 18px;
  font-weight: 600;
}

.section-heading p {
  color: #5e5e5e;
  font-size: 14px;
  font-weight: 500;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins", sans-serif;
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.navigationButton:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

button.primarycolor {
  height: 35px;
  border: none !important;
  margin: 0;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

button.primarycolor:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
<style lang="scss">
#products_review_tbl .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#products_review_tbl_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#products_review_tbl_info {
  position: relative;
  top: 9px;
  left: 324px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  color: var(--primary_brand-80);
}

#products_review_tbl_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#products_review_tbl_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#products_review_tbl_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#products_review_tbl_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#products_review_tbl_paginate ul.pagination li.active {
  border: 1px solid #ebebeb !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#products_review_tbl {
  border-radius: 5px !important;
}

#products_review_tbl thead,
#products_review_tbl thead tr:first-child,
#products_review_tbl thead > tr:first-child > th:first-child {
  background-color: #e7eeef !important;
  border-radius: 5px 0 0 0 !important;
  border-left: 1px solid #d5d5d5 !important;
}

#products_review_tbl thead > tr:first-child > th:last-child {
  border-radius: 0 5px 0 0;
}

#products_review_tbl thead > tr > th {
  border-top: 1px solid #d5d5d5 !important;
  border-right: 1px solid #d5d5d5 !important;
  border-bottom: 1px solid #d5d5d5 !important;
  background-color: #e7eeef !important;
  padding: 16px 32px !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  text-align: center !important;
  color: #050a13 !important;
}

#products_review_tbl tbody > tr > td {
  font-family: "Poppins", sans-serif !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  color: black !important;
}

#products_review_tbl th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#products_review_tbl_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#products_review_tbl_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#products_review_tbl_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#products_review_tbl_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#products_review_tbl_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#products_review_tbl_filter {
  float: left;
  margin-left: -104%;
}

#products_review_tbl_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#products_review_tbl_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#products_review_tbl_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#products_review_tbl_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#products_review_tbl_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#products_review_tbl_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#products_review_tbl_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#products_review_tbl_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#products_review_tbl_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%)
    hue-rotate(138deg) brightness(98%) contrast(95%);
}
</style>
